import * as React from "react"
import { SVGProps } from "react"
const RobotLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={66} height={75} viewBox="0 0 88 100" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(0 2)">
      <ellipse cx={43.685} cy={94.365} fill="#A4A4A3" rx={43.685} ry={3.599} />
      <path fill="#00819D" stroke="#979797" strokeWidth={2.442} d="M27.6 84.008h9.457v7.157H27.6z" />
      <path
        stroke="#0095A6"
        strokeWidth={2.734}
        d="M25.834 83.427c.142 2.413.978 4.281 2.51 5.605 1.532 1.323 4.844 2.26 9.934 2.812"
      />
      <path
        stroke="#004F53"
        strokeWidth={2.734}
        d="M23.66 82.101v6.79h2.756v2.355c0 .188.153.341.342.341h2.168v2.561h10.676a.683.683 0 0 0 .683-.683V92.27a.683.683 0 0 0-.683-.684h-.4v-9.486H23.66Z"
      />
      <path
        stroke="#004F53"
        strokeWidth={2.734}
        d="M25.259 82.846c.298 3.486 1.213 5.89 2.745 7.214 1.532 1.324 4.81 2.235 9.831 2.734"
      />
      <path fill="#00819D" stroke="#979797" strokeWidth={2.442} d="M55.005 84.008h-9.457v7.157h9.457z" />
      <path
        stroke="#0095A6"
        strokeWidth={2.734}
        d="M56.77 83.427c-.14 2.413-.977 4.281-2.509 5.605-1.532 1.323-4.843 2.26-9.933 2.812"
      />
      <path
        stroke="#004F53"
        strokeWidth={2.734}
        d="M61.023 82.101v6.79h-2.757v2.355a.342.342 0 0 1-.342.341h-2.167v2.561H45.08a.683.683 0 0 1-.684-.683V92.27c0-.378.306-.684.684-.684h.399v-9.486h15.543Z"
      />
      <path
        stroke="#004F53"
        strokeWidth={2.734}
        d="M59.424 82.846c-.299 3.486-1.214 5.89-2.746 7.214-1.532 1.324-4.81 2.235-9.83 2.734"
      />
      <path fill="#049E91" d="m38.04 19.861-15.263 3.355-7.366 12.323V80.48h51.485l2.456-11.655V28.714l-2.456-5.498z" />
      <path fill="#14BAA9" d="m22.777 16.506 5.205 6.71h31.032l1.957-5.506-9.78-1.204z" />
      <path
        fill="#FFF"
        d="M59.014 23.216c2.044 1.068 3.434 2.032 4.17 2.891.735.86 1.304 2.185 1.706 3.975h3.68c-.166-2.662-.745-4.772-1.738-6.331-.993-1.56-3.066-3.65-6.218-6.272l-1.6 5.737Z"
      />
      <path
        fill="#088776"
        d="m24.614 16.506 3.787 6.916c-4.457 2.16-7.094 4.41-7.911 6.747-.818 2.338-1.008 10.425-.57 24.26h2.68c1.223 0 2.33.725 2.819 1.847l1.92 4.406v19.8l-13.36-1.178-1.4-52.642c2.001-3.74 3.721-6.218 5.16-7.432 1.44-1.215 3.73-2.123 6.875-2.724Z"
      />
      <path
        stroke="#08625A"
        strokeWidth={3.076}
        d="M28.64 15.693h25.675c8.305 0 15.037 6.732 15.037 15.037v44.625a5.126 5.126 0 0 1-5.126 5.126H17.705a5.126 5.126 0 0 1-5.126-5.126v-43.6c0-8.871 7.19-16.062 16.062-16.062Z"
      />
      <path fill="#0AB7AE" d="M12.036 56.632h5.242l2.494 8.603-1.377 5.426-3.45 1.492-2.366-.439z" />
      <path fill="#39B460" d="m12.036 57.566 2.428 2.819v11.768h-2.428z" />
      <path
        fill="#86DC91"
        d="M32.688 25.291h22a8.885 8.885 0 0 1 8.885 8.885v16.49a2.392 2.392 0 0 1-2.393 2.392H25.17a2.392 2.392 0 0 1-2.393-2.393V35.202c0-5.474 4.438-9.911 9.911-9.911Z"
      />
      <g fillRule="nonzero">
        <path
          fill="#124E2B"
          d="M29.269 43.175c-.295-.041-.376.012-.253.118-.012-.411-.202-.835-.392-1.259 0 0-.02.054-.018-.122a17.295 17.295 0 0 0-.05-.792c.518-5.72 3.822-8.195 9.283-6.77a.82.82 0 0 1 .43.196c.331.183.54.267.747.35 0 0-.042-.053.004.099.348.408.65.663.95.92.32.517.64 1.035 1.044 1.816.207.387.33.51.452.633.02.79.04 1.581.065 2.755a15.649 15.649 0 0 1-.178 1.524c-2.036 4.569-9.417 4.9-12.084.532m6.3-4.64c-.044 1.649.79 2.71 2.453 2.673.686-.016 1.91-.865 1.91-1.336.001-.974-.374-2.322-1.1-2.841-1.244-.89-2.514-.324-3.263 1.504ZM48.77 36.021c4.11-3.015 7.18-2.882 10.244.451.116.102.19.247.301.406.173.228.235.299.298.37.16.39.32.781.56 1.52-.165 1.785-.412 3.222-.658 4.658 0 0 .016.043-.098.107-.483.535-.852 1.005-1.22 1.475 0 0-.009 0-.176.064a563.477 563.477 0 0 1-5.383 1.472c-3.013-.728-4.73-2.66-5.432-5.91-.027-.726-.041-1.09-.056-1.453.299-.712.597-1.424 1.048-2.382.194-.322.235-.398.276-.473.124-.033.216-.106.296-.305m6.622 4.844c1.714.778 3.05.308 3.285-1.498.104-.796-.642-1.978-1.368-2.493-.454-.322-2.202.117-2.303.489-.27.996.035 2.14.386 3.502Z"
        />
        <path
          fill="#DEF5F0"
          d="M35.604 38.343c.714-1.636 1.984-2.201 3.228-1.312.726.52 1.101 1.867 1.1 2.841 0 .471-1.224 1.32-1.91 1.336-1.663.038-2.497-1.024-2.418-2.865ZM55.254 40.727c-.213-1.223-.519-2.368-.248-3.364.1-.372 1.85-.81 2.303-.49.726.516 1.472 1.698 1.368 2.494-.235 1.806-1.57 2.276-3.423 1.36Z"
        />
      </g>
      <path
        fill="#124E2B"
        fillRule="nonzero"
        d="M45.146 48.354c-.704.566-1.483.726-2.081.195-.44-.39-.61-1.1-.852-1.69-.044-.104.133-.329.251-.457.036-.039.244.03.331.102 1.33 1.088 1.329 1.09 2.425-.104.745.653.284 1.278-.074 1.954Z"
      />
      <path
        fill="#2B7610"
        d="M12.036 56.632v15.2l-3.002 2.006-3.075-2.806-1.66-5.797 1.66-3.728zM69.829 56.632v15.2l3.002 2.006 3.819-.537 1.79-6.189c.199-2.606-.646-4.96-2.535-7.06-1.889-2.1-3.914-3.24-6.076-3.42Z"
      />
      <path fill="#39B460" d="M69.829 54.711h-3.05L65.49 72.857l4.339-.704z" />
      <path fill="#0AB7AE" d="M66.78 54.711h-3.207l-1.48 10.524 1.377 5.426.623 2.196h2.686z" />
      <path
        stroke="#025952"
        strokeLinecap="round"
        strokeWidth={2.734}
        d="m14.261 72.571-1.682-.293h0l-2.462 1.334a2.732 2.732 0 0 1-3.478-.755c-2.157-2.842-2.823-6.294-1.997-10.356 2.13-3.596 4.863-5.813 8.198-6.65a5.468 5.468 0 0 1 6.8 5.44l-.174 7.013a4.443 4.443 0 0 1-5.205 4.267ZM66.137 73.163l4.509-.885h0l2.194 1.666a2.73 2.73 0 0 0 3.98-.737c1.975-3.203 2.562-6.772 1.763-10.706-3.103-5.236-7.636-7.94-13.6-8.113a2.05 2.05 0 0 0-2.107 2.051V70.48a2.734 2.734 0 0 0 3.261 2.683Z"
      />
      <path
        stroke="#08625A"
        strokeLinecap="round"
        strokeWidth={3.759}
        d="M40.352 14.8c.134-4.702-.597-7.864-2.193-9.485-1.512-1.536-5.25-2.32-11.213-2.35a1.025 1.025 0 0 1-1.022-1.027V0h0"
      />
      <path fill="#FFF" d="M31.276 58.542h26.177v15.426H31.276z" />
      <path fill="#E4C354" d="M35.696 61.628h19.038v2.742H35.696z" />
      <path fill="#00BAE5" d="M35.696 65.741h19.038v2.742H35.696z" />
      <path
        fill="#3E7D72"
        fillRule="nonzero"
        d="M40.71 71.688c-.124-.209-.23-.351-.243-.504-.06-.695.102-1.272.81-1.325.519-.038.917.152.875.916-.044.805-.3 1.27-1.076 1.102-.105-.023-.204-.083-.366-.189Z"
      />
      <path
        fill="#0E8E80"
        fillRule="nonzero"
        d="M53.689 69.855c.416.189.956.334 1.03.61.08.299-.185.857-.465 1.044-.217.145-.892.006-1.004-.206-.26-.489-.45-1.142.439-1.448ZM49.31 70.01c.124.443.361.953.2 1.188-.177.254-.772.408-1.093.312-.25-.074-.578-.685-.49-.908.206-.514.58-1.08 1.383-.592Z"
      />
    </g>
  </svg>
)
export default RobotLogo
